import axiosClient from "config/axios";
/***
 * get videos from backend
 */
export const getLabsRequests = async (data) => {
  let result = {};
  await axiosClient
    .get("/laboratories/requests/", data)
    .then((response) => {
      result = {
        error: false,
        result: response.data,
      };
    })
    .catch((error) => {
      result = {
        error: true,
        message: "auth__server_error",
      };
    });
  return result;
};
